import api from '../api.js';
import { flatten, getTopIndex } from '../../versa/record.js';
import * as types from '../types.js';

export default {

	html: `
		<style>
			#input #company_id				{ width: 10rem;		}
			#input #id						{ width: 5rem; text-align: right;	}
			#input #order_id				{ width: 5rem; text-align: right;	}
			#input #order_type				{ width: 7rem; 		}
			#input #created_on				{ width: 9rem;		}
			#input #received_on				{ width: 9rem;		}
			#input #warehouse_company_id	{ width: 10rem;		}
			#input #warehouse_id			{ width: 10rem;		}
			#input #location_id				{ width: 5rem;		}
			#input #program_id				{ width: 10rem;		}
			#input #invoice_number			{ width: 7.5rem;	}
			#input #invoice_xml				{ width: 13rem;		}
			#input #volumes					{ width: 5rem; text-align: right;	}
			#input #weight					{ width: 5rem; text-align: right;	}
			#input #status	 				{ width: 10rem;		}
			#input .product 				{ width: 38rem;		}
			#input .unit 					{ width: 7rem;		}
			#input .quantity 				{ width: 4.5rem; text-align: right;	}
			#input .price 					{ width: 6.5rem; text-align: right;	}
		</style>
		<form id="input" class="form" autocomplete="off">
			<datalist id="companies">
			</datalist>
			<datalist id="warehouses">
			</datalist>
			<datalist id="locations">
			</datalist>
			<datalist id="products">
			</datalist>
			<datalist id="units">
			</datalist>
			<datalist id="programs">
			</datalist>
			<div class="fsb">
				<label title="Empresa detentora do registro">Empresa<sup>*</sup>
					<input id="company_id" type="text" list="companies" required>
				</label>
				<label title="Identificador da entrada">Entrada
					<input id="id" type="text" disabled>
				</label>
				<label title="Número do pedido vinculado">Pedido<sup>*</sup>
					<input id="order_id" type="text" required>
				</label>
				<label title="Tipo do pedido vinculado">Tipo<sup>*</sup>
					<input id="order_type" type="text" list="order_types" value="I" required>
				</label>
				<label title="Data e hora de criação da entrada">Criação
					<input id="created_on" type="text" disabled>
				</label>
				<label title="Data e hora de recebimento da mercadoria">Recebimento
					<input id="received_on" type="text" disabled>
				</label>
				<label title="Status da entrada">Status<sup>*</sup>
					<input id="status" type="text" list="input_status" value="10" required>
				</label>
			</div>
			<div class="fsb">
				<label title="Empresa do armazém de recebimento">Destino
					<input id="warehouse_company_id" type="text" list="companies">
				</label>
				<label title="Armazém de recebimento">Armazém
					<input id="warehouse_id" type="text" list="warehouses">
				</label>
				<label title="Posição de recebimento no armazém">Posição
					<input id="location_id" type="text" list="locations">
				</label>
				<label title="Programa da entrada (todos os lotes desta entrada ficarão nesse programa)">Programa
					<input id="program_id" type="text" list="programs">
				</label>
				<label title="Número da nota fiscal">Nota Fiscal
					<input id="invoice_number" type="text">
				</label>
				<label class="file" ><a id="download" download="invoice.xml">XML</a>
					<input id="invoice_xml" type="file" accept=".xml, text/xml" title="Importar XML da nota fiscal">
				</label>
				<label title="Número de volumes">Volumes
					<input id="volumes" type="text">
				</label>
				<label title="Peso total dos volumes">Peso
					<input id="weight" type="text">
				</label>
			</div>
			<div>
				<table>
					<thead>
						<tr>
							<th></th>
							<th>Produto<sup>*</sup></th>
							<th>Unidade<sup>*</sup></th>
							<th>Qtde<sup>*</sup></th>
							<th>Preço Unit<sup>*</sup></th>
						</tr>
					</thead>
					<tbody>
						<tr class="row">
							<td>
								<input id="checkbox-0" type="checkbox">
							</td>
							<td title="Produto">
								<input id="product_id-0" class="product" type="text" list="products">
							</td>
							<td title="Unidade de compra">
								<input id="unit_id-0" class="unit" type="text" list="units" required>
							</td>
							<td title="Quantidade">
								<input id="quantity-0" class="quantity" type="text" required>
							</td>
							<td title="Preço unitário de compra">
								<input id="unit_price-0" class="price" type="text" required>
							</td>
						</tr>
					</tbody>
				</table>
			</div>
			<div class="fsb mtm">
				<span>
					<img class="bn_Invert" src="img/check.svg" title="Inverter caixas de seleção">
					<img class="bn_Clear" src="img/clear.svg" title="Apagar conteúdo das linhas selecionadas">
					<img class="bn_Insert" src="img/add.svg" title="Anexar uma nova linha">
					<img class="bn_Remove" src="img/remove.svg" title="Remover linhas selecionadas">
					<img class="bn_MoveUp" src="img/up.svg" title="Mover linhas selecionadas para cima">
					<img class="bn_MoveDn" src="img/down.svg" title="Mover linhas selecionadas para baixo">
				</span>
				<span>
					<button class='bn_Escape button'>Fechar</button>
					<button class='bn_Enter button'>Salvar</button>
				</span>
			</div>
		</form>
	`,

	form: 
	{
		selector: '#input',
		init(formset)	// Must not be async as init seq must be preserved
		{
			formset.loadList('#companies', 'companies', { labels: ['nick'] });
			this.getFieldByName('order_id').subscribe(['change'], this.checkCondition.bind(formset), false);	// once = false
			this.getFieldByName('order_type').subscribe(['change'], this.checkCondition.bind(formset), false);	// once = false
			this.getFieldByName('invoice_xml').subscribe(['change'], this.enableDownload.bind(formset), false);	// once = false
			document.querySelector('#invoice_xml').addEventListener('change', this.fillItemsFromXML.bind(formset));
			Object.getPrototypeOf(this).init.call(this);
		},
		checkCondition(ev, publisher, value)
		{
			let company_id = this.form.getFieldByName('company_id').getValue();
			let order_id = this.form.getFieldByName('order_id').getValue();
			let order_type = this.form.getFieldByName('order_type').getValue();
			let key = String([company_id, order_type, order_id])
			if (company_id < 0 || order_type < 0 || !order_id || key == this.last_key)
				return;
			let is_edit = this.form.getFieldByName('id').getValue();
			if (!is_edit || (is_edit && this.last_key))		// If insert (no id) fill it now; If edit (has id) fill it only after 2nd change (has last_key)
				this.form.fillItems.call(this, company_id, order_type, order_id);
			this.last_key = key;
		},
		async fillItems(company_id, order_type, order_id)
		{
			let items; 
			switch (order_type)
			{
				case 'I':
					items = await api.call(api.select_pending_input_items, company_id, order_id);
					break;
				case 'O':
					let order = await api.call(api.select_output_order, company_id, order_id);
					items = order.items;
					break;
			}
			if (items)
			{
				this.clearAllRows();
				let record = flatten({ 'items': items }, 'items');
				this.appendRows(getTopIndex(record) - this.getEnabledRowsIndices().length + 1);
				this.form.setValues(record);
				this.form.refresh();
			}
		},
		enableDownload(ev, publisher, value)
		{
			if (value)
			{
				let anchor = document.querySelector('#download');
				anchor.setAttribute('href', `data:text/xml;base64,${value}`);
				anchor.removeAttribute('disabled');
			}
		},
		fillItemsFromXML(ev)
		{
			let reader = new FileReader();
			reader.onloadend = async () => 
			{
				let data = {
					'company_id': this.form.getFieldByName('company_id').getValue(),
					'order_type': this.form.getFieldByName('order_type').getValue(),
					'order_id': this.form.getFieldByName('order_id').getValue(),
					'file': reader.result.slice(reader.result.indexOf(',') + 1)
				};
				let result = await api.call(api.import_xml, data);
				this.form.setValues(flatten(result, 'items'));
				this.form.refresh();
			};
			reader.readAsDataURL(ev.target.files[0]);
		}
	},
	
	fields: [
		{ properties: { selector: '#company_id' }, types: [types.pubsub(), types.datalist()] },
		{ properties: { selector: '#id' }, types: [types.number(0, 2)] },
		{ properties: { selector: '#order_id' }, types: [types.pubsub(), types.number(0, 2)] },
		{ properties: { selector: '#order_type' }, types: [types.pubsub(), types.opt_order_type(), types.datalist()] },
		{ properties: { selector: '#created_on' }, types: [types.datetime()] },
		{ properties: { selector: '#received_on' }, types: [types.datetime()] },
		{ properties: { selector: '#warehouse_company_id' }, types: [types.pubsub(), types.datalist()] },	
		{ properties: { selector: '#warehouse_id' }, types: [types.pubsub(), types.datalist(), types.observer('warehouse_company_id'), types.obs_load_options('warehouses')] },
		{ properties: { selector: '#location_id' }, types: [types.pubsub(), types.datalist(), types.observer('warehouse_id'), types.obs_load_options('locations', { labels: ['address'], sep: '-', key: 'warehouse_company_id' })] },
		{ properties: { selector: '#program_id' }, types: [types.pubsub(), types.datalist(), types.observer('company_id'), types.obs_load_options('programs', { labels: ['name'] })] },
		{ properties: { selector: '#invoice_number' }, types: [] },
		{ properties: { selector: '#invoice_xml' }, types: [types.pubsub(), types.file()] },
		{ properties: { selector: '#volumes' }, types: [types.number(0, 2)] },
		{ properties: { selector: '#weight' }, types: [types.number(3)] },
		{ properties: { selector: '#status' }, types: [types.opt_input_status(), types.datalist()] },
		{ properties: { selector: '#checkbox-0' }, types: [types.checkbox()] },
		{ properties: { selector: '#product_id-0' }, types: [types.pubsub(), types.datalist(), types.observer('company_id'), types.obs_load_options('products', { labels: ['sku', 'name'] })] },
		{ properties: { selector: '#unit_id-0' }, types: [types.pubsub(), types.datalist(), types.observer(['company_id', 'product_id-0']), types.obs_unit(1)] },
		{ properties: { selector: '#quantity-0' }, types: [types.number(0, 2)]},
		{ properties: { selector: '#unit_price-0' }, types: [types.number(4)] },
	]

};

